// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4 5V21H15V23H2V5H4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M6 1H16L21 6V19H6V1ZM15 3V7H19L15 3Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-copy-filled')
export default class FileCopyFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-copy-filled',
    }
  }
}
